import { render, staticRenderFns } from "./PetBreeds.vue?vue&type=template&id=56111d5a&scoped=true"
import script from "./PetBreeds.vue?vue&type=script&lang=js"
export * from "./PetBreeds.vue?vue&type=script&lang=js"
import style0 from "./PetBreeds.vue?vue&type=style&index=0&id=56111d5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56111d5a",
  null
  
)

export default component.exports